<template>
	<div>
		<div class="row">
			<div class="mb-3">          
				<el-collapse>
					<el-collapse-item>
						<template slot="title">
							<span style="color:#606266;font-size:14px;"><i class="header-icon el-icon-search"></i>&nbsp;&nbsp;&nbsp;Filter</span>
						</template>
						<el-form label-position="top" label-width="100px">
							<div class="row">
								<div class="col-md-6">
									<el-form-item label="Vendor Name:">
										<el-select v-model="vendorId" clearable filterable placeholder="Vendor Name" size="medium" style="width:100%;">
											<el-option v-for="item3 in vendor.list" :key="item3.VendorID + '_' + tabName" :label="item3.VendorName" :value="item3.VendorID">
											</el-option>
										</el-select>
									</el-form-item>
								</div>

								<div class="col-md-6" v-if="tabName=='progress_hutang'">	
									<el-form-item label="Date Range:">
										<div class="block">								
											<el-date-picker
											v-model="dateRange"
											type="daterange"
											align="right"
											size="small" 
											unlink-panels
											range-separator="-"
											start-placeholder="Start date"
											end-placeholder="End date"
											format="yyyy-MM-dd"
											value-format="yyyy-MM-dd"
											:picker-options="pickerOptions">
											</el-date-picker>
										</div>
									</el-form-item>
								</div>

								<div class="col-md-6" v-if="tabName == 'hutang'">
									<el-form-item label="Fungsi:">
										<el-select v-model="fungsi" clearable filterable placeholder="Fungsi" size="medium" style="width:100%;">
											<el-option v-for="item3 in options.fungsi" :key="item3.FungsiName" :label="item3.FungsiName" :value="item3.FungsiName">
											</el-option>
										</el-select>
									</el-form-item>
								</div>
							
								<div class="col-md-6" v-if="tabName == 'hutang'">
									<el-form-item label="Group">
										<el-radio-group v-model="utanggroup" size="small" name="group">
											<el-radio-button :label="item5.value" v-for="(item5, index5) in options.utanggroup" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>

								<div class="col-md-6" v-if="tabName == 'hutang'">
									<el-form-item label="PO Number">
										<el-input placeholder="Type PO Number ..." v-model="ponumber" maxlength="50" clearable="true"></el-input>
									</el-form-item>
								</div>

							</div>
														
							<div class="row mt-2">
								<div class="col-md-6">
									<el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="width:100%;">Apply Filter</el-button>
								</div>
							</div>
						</el-form>
					</el-collapse-item>
				</el-collapse>
			</div>

			<div class="mt-0">
				<ReportResultTable :reportname="'VendorReport'" :reportdata="reportdata" :loading="loading.table" :reporturl="urlRequestParams" :issuccess="loading.isSuccess" style="width:100%;"/> 
			</div>
		</div>
	</div>
</template>

<script>

import Customer from '@/components/page/Customer.js'
import ReportResultTable from '@/views/pages/ReportResultTable2.vue'
import { Rainbow, FuelColor, Config, Penanggalan, AxiosWithJar } from '@/utility.js'
import LineChart from '@/components/chart/LineChart.js'
import BarChart from '@/components/chart/BarChart.js'

export default
{
	extends: Customer,
	props: ['tabIndex','tabName', 'tabLabel'],
	components: { 
		//ReportParamSelect,
		ReportResultTable,
		//LineChart,
		//BarChart,
		//Loader,
	},

	data(){
		return {
			date: { 
				Start: this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().tahunSekarang,
				End: this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin, 
			},
			charttype: 'linechart', //barchart //linechart
			urlRequestParams: '',
			dateRange: [this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().tahunSekarang,this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin], 
			
			options: {
				period:[
					{ value: '', name: 'ALL' },
					{ value: 'monthly', name: 'MONTHLY'  },
					{ value: 'yearly', name: 'YEARLY' },
				],
				detail1:[
					{ value: "", name: "ALL" }, 
					{ value: "customer", name: "BY CUSTOMER" }, 
				],
				category:[
					{ value: "", name: "ALL" }, 
					{ value: "tipe", name: "BY TYPE", field: "Tipe" }, 
					{ value: "category", name: "BY CATEGORY", field: "Category" }, 
					{ value: "RFID", name: "RFID" }, 
					{ value: "VOUCHER", name: "VOUCHER" }, 
					{ value: "STORE", name: "STORE" }, 
					{ value: "LPG", name: "LPG" }, 
				],
				group:[
					{ value: "", name: "ALL" }, 
					{ value: "group", name: "BY GROUP", field: "GroupName"  }, 
					{ value: "34", name: "PEMERINTAH" }, 
					{ value: "58", name: "AFILIASI" }, 
					{ value: "59", name: "SWASTA" },
					{ value: "P1", name: "PANGKALAN LPG" },
				],
				active:[
					{ value: "", name: "ALL" }, 
					{ value: "1", name: "ACTIVE" }, 
					{ value: "0", name: "NON ACTIVE" }, 
				],
				chartparam:[
					{ value: "Amount", name: "BY AMOUNT" }, 
					{ value: "CustCount", name: "BY NUM OF CUSTOMER" }, 
				],
				utanggroup:[
					{ value: "detail", name: "ALL" }, 
					{ value: "aging", name: "AGING" }, 
					{ value: "vendor", name: "VENDOR" },
				],
				fungsi: [],
			},

			vendor: {
				list:[],
			},

			fungsi: '',
			utanggroup: 'detail',
			ponumber: '',
			vendorId: this.$route.query.vendor ? this.$route.query.vendor : '',
			tabIndexParam: this.$route.query.tab ? this.$route.query.tab : '',
			reportdata: [],
			chartdata: [],
			showchart: false,
			stacked: true,
			period: this.$route.query.period ? this.$route.query.period : '',
			detail1: this.$route.query.detail1 ? this.$route.query.detail1 : '',
			category: this.$route.query.category ? this.$route.query.category : 'category',
			group: this.$route.query.group ? this.$route.query.group : '',
			cust: this.$route.query.cust ? this.$route.query.cust : '',
			active: this.$route.query.active ? this.$route.query.active : '',
			chartparam: "Amount",
			
			loading: {
				table: false,
				chart: false,
				isSuccess: false,
			},

			pickerOptions: {
				shortcuts: [{
					text: 'Last week',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: 'Last month',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: 'Last 3 months',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
					picker.$emit('pick', [start, end]);
					}
				}]
			},

			limit: 100,

		}
	},
	watch:
	{
		reportdata() { this.refreshChart(); },
		stacked() { this.refreshChart(); },

	}, 
    mounted()
    {
		Array.from(document.querySelectorAll('aside li.nav-item a')).map((e)=>{e.classList.remove('active')})
        document.querySelector('li.nav-item a.'+window.location.pathname.split('/')[1]).classList.add('active')
		
        this.$emit('childrenRoute');
		this.getVendorList()
		this.resumePilihan()
		
    },
    methods:{
		floatingSearchForm(){
			document.querySelector('.search.form').classList.toggle('floating')            
		},
		searchFilterButtonClick(){
			document.querySelector('li.filter').classList.toggle('down')
			var select=document.querySelectorAll('.search.form')
			Array.from(select).map((e)=>{e.classList.toggle('minimize')})
		},

		refreshChart() {
			let opt = this.getoption(this.category, this.options.category)
			let a = opt && opt.field ? opt.field : ""

			opt = this.getoption(this.group, this.options.group)
			if (opt && opt.field) a = opt.field
			
			let b = "Period"
			let c = Rainbow

			let div = this.chartparam == "Amount" ? 1000000 : 1;
			
			this.chartdata = this.processBarChart(this.reportdata.data, a, "", this.chartparam, false, b, "", div, 2, c, false, false, false, this.stacked);
		},

		async resumePilihan() {
			this.urlRequestParams=Config().apiURL
			//if (this.tabName == 'hutang') 

			if(this.tabIndexParam != '' && this.vendorId == '')
				this.urlRequestParams+='/vendor/top-utang?' //get top hutang (when clicked from top 10 page)
			else if (this.tabName == 'hutang')
				this.urlRequestParams+='/vendor/utang?'
			else if(this.tabName == 'progress_hutang')
				this.urlRequestParams+='/vendor/progress-hutang?'

			//this.urlRequestParams+='&date-range-start='+this.date.Start
			//this.urlRequestParams+='&date-range-end='+this.date.End
			this.urlRequestParams+='&date-range-start='+ this.dateRange[0]
			this.urlRequestParams+='&date-range-end='+ this.dateRange[1]

			/*
			this.urlRequestParams+='&period='+this.period
			this.urlRequestParams+='&detail='+this.detail1
			this.urlRequestParams+='&category='+this.category
			this.urlRequestParams+='&group='+this.group
			this.urlRequestParams+='&active='+this.active
			*/
			this.urlRequestParams+='&vendor='+this.vendorId 
			this.urlRequestParams+='&group='+this.utanggroup
			this.urlRequestParams+='&ponumber='+this.ponumber
			this.urlRequestParams+='&fungsi='+encodeURIComponent(this.fungsi)
			this.urlRequestParams+='&limit='+this.limit

			//set limit to 0 (no limit) after first load //
			this.limit = 0

			this.loading.table = true;
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					this.loading.isSuccess = true;
					this.reportdata = response.data;
					this.tabIndexParam = ''

					if(this.options.fungsi.length <=0 && this.tabName =='hutang') {
						this.generateFungsiList()
					}
				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.table = false;
				})
        },

		async getVendorList() {
			let url = Config().apiURL + "/vendor/vendor-list"
			await AxiosWithJar().get(url).then(result => {
				if (result.data.vendor.length) {
					this.vendor.list = result.data.vendor;
				}
			})
		},

		generateFungsiList() {
			const groupedData = [];
			this.reportdata.data.forEach((item) => {
				const branchKey = item.FungsiName //`${item.CategoryID} - ${item.BranchName}`;
				const existingGroup = groupedData.find((group) => group.branchKey === branchKey);

				if (existingGroup) {
					//existingGroup.categories.add(item.TagProduct);
				} else {
					groupedData.push({
						branchKey,
						//TagProduct: item.TagProduct,
						FungsiName: item.FungsiName
					});
				}
			});

			this.options.fungsi = groupedData
			//return groupedData;
		},
		
		applyFilter() {
			this.resumePilihan()
        },
			
    }
}
</script>
<style>

.fade-enter-active, .fade-leave-active {
  opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>